import { getCurrentTimestamp, getRandomStringSimple } from '@/common/utils';

export type SocketLogMessageLevel = 'info' | 'warn' | 'error' | 'success';
export type SocketLogMessage = {
  id: string;
  level: SocketLogMessageLevel;
  timestamp: string;
  message: string;
};

export type LogListener = (row: SocketLogMessage) => void;
type LogStore = {
  log: SocketLogMessage[];
  listeners: LogListener[];
};

const logStore: LogStore = {
  log: [],
  listeners: [],
};

const MAX_STORE_LENGTH = 400;

function log(level: SocketLogMessageLevel, msg: string) {
  const timestamp = getCurrentTimestamp(false);
  const id = getRandomStringSimple();
  const newRow = Object.freeze({
    id,
    timestamp,
    level,
    message: msg,
  });

  logStore.log.push(newRow);

  if (logStore.log.length >= MAX_STORE_LENGTH) {
    const numToRemove = logStore.log.length - MAX_STORE_LENGTH;
    logStore.log = logStore.log.slice(numToRemove);
  }

  for (const listener of logStore.listeners) {
    listener(newRow);
  }
}

export const logger = {
  log(level: SocketLogMessageLevel, msg: string) {
    log(level, msg);
  },
  info(msg: string) {
    log('info', msg);
  },
  warn(msg: string) {
    log('warn', msg);
  },
  error(msg: string) {
    log('error', msg);
  },
  success(msg: string) {
    log('success', msg);
  },
};

export function getCurrentLogSlice() {
  return logStore.log.slice();
}

export function removeLogMessage(...idList: string[]) {
  if (!idList || idList.length < 1) {
    return;
  }
  logStore.log = logStore.log.filter((l) => !idList.includes(l.id));
}

export function addLogListener(fn: LogListener) {
  if (logStore.listeners.includes(fn)) {
    return;
  }
  logStore.listeners.push(fn);

  if (logStore.log.length > 0) {
    fn(logStore.log[logStore.log.length - 1]);
  }
}

export function removeLogListener(fn: LogListener) {
  logStore.listeners = logStore.listeners.filter((l) => l !== fn);
}
